import { createRoot } from 'react-dom/client';

import Lobby from './main';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Lobby />
);
